import { MouseEvent, useState } from 'react';
import { Icon, Text } from '@pairy/pds-react';
import cn from 'classnames';

import * as Styled from '../index.styles';

import DeletePdfFileModal from './DeletePdfFileModal';

interface Props {
  fileId: number;
  fileName: string;
  isDisabled: boolean;
  handleDisabledButtonClick: (e: MouseEvent<HTMLButtonElement>) => void;
}

const DeleteButton = ({
  fileId,
  fileName,
  isDisabled,
  handleDisabledButtonClick,
}: Props) => {
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

  const handleClickDeleteButton = (e: MouseEvent<HTMLButtonElement>) => {
    if (isDisabled) {
      handleDisabledButtonClick(e);
      return;
    }

    e.stopPropagation();
    setIsOpenDeleteModal(true);
  };

  return (
    <>
      <Styled.RedBorderButton
        className={cn('', {
          'is-disabled': isDisabled,
        })}
        onClick={handleClickDeleteButton}
      >
        <Icon icon="ph:trash" size={17} color="inherit" />
        <Text variant="sm-medium" color="inherit">
          삭제
        </Text>
      </Styled.RedBorderButton>
      <DeletePdfFileModal
        isOpen={isOpenDeleteModal}
        setIsOpen={setIsOpenDeleteModal}
        fileId={fileId}
        fileName={fileName}
      />
    </>
  );
};

export default DeleteButton;
